import React, { useState, useEffect, useRef } from "react";
import { FiLayout } from "react-icons/fi";
import "./AreaFilter.css"; // CSS for AreaFilter

const AreaFilter = ({ applyAreaFilter }) => {
  const [isAreaDropdownOpen, setIsAreaDropdownOpen] = useState(false);
  const [minArea, setMinArea] = useState("");
  const [maxArea, setMaxArea] = useState("");
  const dropdownRef = useRef(null); // Ref for the dropdown container

  // Toggle the dropdown open/close
  const toggleAreaDropdown = () => {
    setIsAreaDropdownOpen(!isAreaDropdownOpen);
  };

  // Apply the filter and close the dropdown
  const applyFilter = () => {
    const min = minArea ? parseInt(minArea, 10) : null;
    const max = maxArea ? parseInt(maxArea, 10) : null;
    applyAreaFilter(min, max); // Call the parent function to apply the filter
    setIsAreaDropdownOpen(false); // Close dropdown after applying the filter
  };

  // Handle click outside the dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsAreaDropdownOpen(false); // Close the dropdown if clicked outside
      }
    };

    // Add event listener to the document for click events
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  return (
    <div className="filter-container" ref={dropdownRef}>
      {/* Toggle button for area filter */}
      <button onClick={toggleAreaDropdown} className="filter-button">
        <FiLayout />
        Sipërfaqja
      </button>

      {/* Dropdown to input min and max areas */}
      {isAreaDropdownOpen && (
        <div className="dropdown">
          <input
            type="number"
            placeholder="Min"
            value={minArea}
            onChange={(e) => setMinArea(e.target.value)}
          />
          <span> - </span>
          <input
            type="number"
            placeholder="Max"
            value={maxArea}
            onChange={(e) => setMaxArea(e.target.value)}
          />
          <button onClick={applyFilter}>Apliko</button>
        </div>
      )}
    </div>
  );
};

export default AreaFilter;
